import Notify from "devextreme/ui/notify";

export const calculateEditablePeriod = (yearMonth, allowedPeriod) => {
  const now = new Date();
  const currentYearMonth = now.getFullYear() * 12 + (now.getMonth() + 1);

  const [year, month] = yearMonth.split("-").map(Number);
  const selectedYearMonth = year * 12 + month;
  return currentYearMonth - selectedYearMonth <= allowedPeriod;
};

export const camelToTitle = (camelCase) => {
  // 첫 번째 단어를 제외하고, 각 단어의 앞에 공백을 추가합니다.
  let result = camelCase.replace(/([A-Z])/g, " $1");
  // 각 단어별로 첫 글자를 대문자로 만듭니다.
  result = result
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
  return result.trim();
};

export const formatDateString = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  const formattedDate = `${year}년 ${month}월 ${day}일`;
  return formattedDate;
};

// 날짜 객체 생성 및 시간대 오프셋 적용을 위한 함수
export const getDateWithOffset = (dateString) => {
  return new Date(new Date(dateString).getTime() - 9 * 60 * 60 * 1000);
};

export const handleCellStyle = (e) => {
  if (e.rowType === "header") {
    e.cellElement.style.textAlign = "center";
    e.cellElement.style.fontWeight = "bold";
    e.cellElement.style.backgroundColor = "#E2EFDA";
  }
};

export const toastMsg = (msg, isSuccess) => {
  Notify(
    {
      message: msg,
      height: 45,
      width: "100%",
      minWidth: 150,
      type: isSuccess ? "success" : "info",
      displayTime: 3500,
      animation: {
        show: {
          type: "fade",
          duration: 400,
          from: 0,
          to: 1,
        },
        hide: { type: "fade", duration: 40, to: 0 },
      },
    },
    {
      position: "bottom left",
      direction: "up-push",
    }
  );
};
